<template>
  <main>
    
    <!-- Header -->
    <header class="view-admin__header">
      <div class="container">
        <actions-button 
          class="view-admin__back"
          icon-pre="arrow-left" 
          :href="{ name: 'sayl-oat-catalog.catalog' }"
          size="s">{{ $t('sayl-oat.back') }} </actions-button>

        <div class="view-admin__infos">
          <div class="view-admin__meta">
            <h2 class="view-admin__overline">{{ $t('sayl-oat.burger_actions_admin') }}</h2>
          </div>
          <h1 class="view-admin__title">{{ shop.name }}</h1>
        </div>
      </div>
    </header>

    <!-- Body -->
    <section class="view-admin__body">
      <div class="container">

        <!-- Table selection -->
        <article class="view-admin__article view-admin__tables">
          <header class="view-admin__article-header">
            <h3 class="view-admin__article-title">{{ $t('sayl-oat.admin_table') }}</h3>
            <p class="view-admin__article-description">{{ $t('sayl-oat.admin_table_description') }}</p>
          </header>

          <div v-if="tablesList" class="view-admin__artice-body">
            <ul class="tables__list">
              <li
                :class="{ 'tables__item': true, '-is-active': table == entry.value }"
                v-for="entry in tablesList"
                :key="entry.value">
                <button 
                  class="tables__table"
                  @click="table = entry.value; onConfirm()">{{ entry.label }}</button>
              </li>
            </ul>

            <!-- <forms-select 
              :placeholder="$t('sayl-oat.placeholder_table_number')"
              :options="tablesList"
              v-model="table"
              :errors="error"
              @change="error = []"
              >{{$t('sayl-oat.table_number_entry')}}</forms-select> -->
            
            <actions-button
              v-if="false"
              appearance="primary"
              @click="onConfirm"
              >{{ $t('sayl-oat.admin_table_action')}}</actions-button>

          </div>
        </article>

        <!-- Reset -->
        <article class="view-admin__article">
          <header class="view-admin__article-header">
            <h3 class="view-admin__article-title">{{ $t('sayl-oat.admin_reset') }}</h3>
            <h3 class="view-admin__article-description">{{ $t('sayl-oat.admin_reset_description') }}</h3>
          </header>

          <div class="view-admin__article-body">
            <actions-button
              @click="onReset"
              intent="danger"
              >{{ $t('sayl-oat.admin_reset_action') }}</actions-button>
          </div>
        </article>
      </div>
    </section>

  </main>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'AdminView',

  data() {
    return { 
      table: null,
      error: []
    }
  },

  computed: {
    ...mapState({
      shop: state => state['sayl-oat'].shop,
      tableNumber: state => state['sayl-oat'].tableNumber,
      tables: state => state['sayl-oat'].tables,
    }),
   
    tablesList() {
      let ret = [];

      this.tables && this.tables.forEach(t => {
        ret.push({
          label: t.name,
          value: t.id
        });
      });

      return ret;
    }
  },

  methods: {
    ...mapActions({
      reset: 'reset',
    }),
    
    ...mapMutations({
      setTableNumber: 'setTableNumber'
    }),

    onConfirm() {
      if(['', null, undefined].includes(this.table)){
        this.error = [this.$t('sayl-oat.table_error')];
      } else {
        localStorage.setItem('table', this.table);
        this.$router.push({name: 'sayl-oat-catalog.catalog'});
      }
    },

    onReset() {
      localStorage.removeItem('table'); 

      let ok, ko;
      const p = new Promise((resolve, reject) => {
        ok = resolve;
        ko = reject;
      });
      this.$bus.$emit('sayl-oat.reset', { resolve: ok, reject: ko });

      p.then(() => { 
        window.location = `/`;
      }).catch((e) => {
        this.$notification({
          title: 'error',
          description: 'error 1',
          type: 'error'
        })
      });
    }
  },

  mounted() {
    if(JSON.parse(localStorage.getItem('admin')) !== true) {
      this.$router.push({name: 'sayl-oat-catalog.catalog'});
    }

    this.table = localStorage.getItem('table');
  },

  beforeDestroy() {
    localStorage.removeItem('admin');
  }
}
</script>
